// extracted by mini-css-extract-plugin
export default {"heading":"Terms_heading__Nhtc9","listTerms":"Terms_listTerms__7yNWF","listCircledDecimal":"Terms_listCircledDecimal__Mhm03","terms":"Terms_terms__HQ5db"};